import type {
  AccountType,
  AccountTypeFlags,
} from "../../convex/schemas/validators/enums";

export function resolveAccountTypes(
  flags: AccountTypeFlags | undefined,
  legacyAccountType: AccountType | undefined,
): AccountType[] {
  const accountTypes: AccountType[] = [];
  if (flags?.buyer) accountTypes.push("buyer");
  if (flags?.vendor) accountTypes.push("vendor");
  if (flags?.freightCarrier) accountTypes.push("freight_carrier");
  if (accountTypes.length === 0 && flags?.prospect) accountTypes.push("buyer");
  if (accountTypes.length === 0 && legacyAccountType && flags === undefined) {
    accountTypes.push(legacyAccountType);
  }
  return accountTypes;
}

export function canHoldPayoutAccount(accountTypes: readonly AccountType[]): boolean {
  return accountTypes.includes("buyer") || accountTypes.includes("vendor");
}
